import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import moment from 'moment';
import * as _ from "lodash";
import { TranslateService } from '@ngx-translate/core';
import { DocumentMetadata } from 'src/app/models/documentMetadata';
import { DocumentService } from 'src/app/services/document.service';

@Component({
  selector: 'app-document-timeline',
  templateUrl: './document-timeline.component.html',
  styleUrls: ['./document-timeline.component.scss']
})
export class DocumentTimelineComponent implements OnInit, OnChanges {
  @Input() metadata?: DocumentMetadata[] = [];
  @Input("period") period?: {
    start: moment.Moment,
    end: moment.Moment,
    dates: moment.Moment[]
  } = {
      start: moment(),
      end: moment(),
      dates: []
    };
  @Input() shown: boolean = false;

  @Input() startFilter?: moment.Moment;
  @Input() endFilter?: moment.Moment;

  years: number[] = [];
  months: string[] = [];

  heatmap: {
    [year: number]: number[]
  } = {};

  format: string = '-';

  constructor(
    private documentService: DocumentService,
    private translateService: TranslateService
  ) {
    moment.locale(this.translateService.currentLang)
  }

  ngOnInit(): void {
    this.months = _.range(1, 13).map((step) => moment.utc(step, "M").format("MMM"))
    this.buildHeatmap();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (((changes['startFilter'] && changes['startFilter']['currentValue'] != changes['startFilter']['previousValue'])
      || (changes['endFilter'] && changes['endFilter']['currentValue'] != changes['endFilter']['previousValue']))
    ) {
      console.log(changes)
      this.buildHeatmap();
    }
  }


  // getConfidence(user: string) {
  //   return (this.metadata?.find(datum => datum.type === MetadataType.USER && datum.value === user.replace(' ', '_'))?.confidence ?? 0) * 100
  // }

  buildHeatmap() {
    this.heatmap = {};
    this.years = [];
    const period = this.filtered();
    console.log(period)
    if (period && period.start && moment.utc(period.start).isValid() && period.end && moment.utc(period.end).isValid()) {
      const start = moment.utc(period.start);
      const end = moment.utc(period.end)
      let date = start.clone();
      while (date.year() <= end.year()) {
        this.years.push(date.year());
        date = date.add(1, 'year');
      }
      this.years.forEach(year => {
        this.heatmap[year] = []
        this.months.forEach(month => {
          this.heatmap[year].push(0)
        })
      })
      if (period.dates)
        period.dates.forEach(date => {
          const momentDate = moment.utc(date);
          this.heatmap[momentDate.year()][momentDate.month()] = 100;
        })
    } else {
      let date = moment.utc().add(-3, 'years').clone();
      while (date.year() <= moment.utc().year()) {
        this.years.push(date.year());
        date = date.add(1, 'year');
      }
      this.years.forEach(year => {
        this.heatmap[year] = []
        this.months.forEach(month => {
          this.heatmap[year].push(0)
        })
      })
    }

  }

  hasFilters(): boolean {
    return this.startFilter !== undefined && this.endFilter !== undefined ? true : false;
  }

  filtered() {
    if (!this.hasFilters()) {
      if (this.period && this.period.start && this.period.end) {
        this.format = this.documentService._period(this.period)
        console.log(this.format)
      }
      return this.period;
    }
    const start = this.startFilter ? moment(this.startFilter, 'YYYY-MM-DD').startOf('day') : undefined;
    const end = this.endFilter ? moment(this.endFilter, 'YYYY-MM-DD').endOf('day') : undefined;
    const dates = (this.period && this.period.dates) ? this.period?.dates.filter((date) => {
      const dateMoment = moment(date, 'YYYY-MM-DD').startOf('day');
      return (start ? start.isSameOrBefore(dateMoment) : true)
        &&
        (end ? end.isSameOrAfter(dateMoment) : true)
    }) : []

    if (dates.length > 0) {
      this.format = this.documentService._period({
        start: moment.min(dates),
        end: moment.max(dates),
        dates
      })
    } else {
      this.format = '-';
    }

    return {
      start: start ? start : this.period?.start,
      end: end ? end : this.period?.end,
      dates: dates
    }
  }


}
